import React, { useState } from "react";
import "../styles/Rider.css";
import { ReactComponent as AppStore } from "../assets/images/appstore.svg";
import { ReactComponent as PlayStore } from "../assets/images/googleplay.svg";
import { Link } from "react-router-dom";
import "../styles/driver.css";

const Driver = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [hoverIndex, setHoverIndex] = useState(null); // ✅ Track hover
  const isMobile = window.innerWidth <= 600;

  const toggleQuestion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const questions = [
    {
      question: "How do I know someone has requested a ride?",
      answer:
        "You will receive a notification when someone requests a ride. When signed into the driver app, stay alert for any notifications. You have 20 seconds to accept the ride request. Tap anywhere on your screen to confirm the ride.",
    },
    {
      question:
        "Berymo Driver app shows my account is online. What does this mean?",
      answer:
        "When the app shows you are online, this infers that you are ready to accept a ride request. When you are online, riders can see you on the map before they request a ride. Once matched with a rider, the app's built-in navigation system will direct you to the rider's location.",
    },
    {
      question: "How do I contact riders?",
      answer: (
        <ol className="faq-steps">
          <p>
            Tap the drop-down menu in the upper-right corner of the driver app
            and select Contact to call your rider.
            <br />
            <br />
            After accepting a ride request, the app will also show an option to
            call the rider directly. For safety reasons, Berymo does not
            support texting—only voice calls are allowed to ensure privacy and
            protection for both drivers and riders.
          </p>
        </ol>
      ),
    },
    {
      question: "How much do Berymo Drivers make?",
      answer:
        "Berymo drivers make a flat rate per rider - simple - no variable fares. Berymo Drivers can make up to $35 an hour.",
    },
    {
      question: "Is there any requirement to drive with Berymo?",
      answer:
        "Berymo Drivers must be 21 years of age, have a valid work permit, and a state-issued driver's license. All three criteria must be met in order to be considered eligible for driving with Berymo Driver.",
    },
    {
      question: "What is Instant Pay?",
      answer:
        "Instant Pay is a way to cash out your earnings prior to the standard Friday deposit. Earnings can be transferred to your account within a few hours depending on your bank's processing time.",
    },
    {
      question: "How does tipping work?",
      answer:
        "Riders can tip their drivers at the end of their ride. Your rider can add a tip in the app, through the Berymo App. Berymo takes zero service fees on tips, and tips will be available for Instant Pay shortly after the trip is completed.",
    },
  ];

  return (
    <>
      <div className="full-container">
        {/* HERO SECTION */}
        <div className="hero-sec">
          <div className="hero-text">
            <h1>
              Start driving
              <br />
              with us
            </h1>
            <p>Earn great money on your own schedule.</p>
            <a href="https://apps.apple.com/us/app/berymo-driver/id1440035432">
              <button className="ride">Sign Up To Driver</button>
            </a>
          </div>
          <div className="all-images">
            <img
              src="/images/driver.jpg"
              alt="Hero"
              className="hero-images"
              style={{ marginTop: "70px" }}
            />
          </div>
        </div>

        {/* WHY DRIVE WITH US */}
        <div className="berymo-containerss">
          <h2>Why Ride with us</h2>
          <p className="berymo-subtextss">
            As a Berymo driver, you work on your own schedule. Earn extra cash
            whenever you want and wherever you are.
          </p>
          <div className="berymo-gridss">
            {[
              {
                img: "banknote",
                title: "Earn great money",
                text: "Berymo drivers get paid per rider, making your income simple and transparent. As a driver for Berymo, you can make up to $35 an hour.",
              },
              {
                img: "speedometer",
                title: "Less miles, more riders",
                text: "Berymo drivers only operate within an 8 mile radius - maximizing the riders you transport and reducing high mileage on your car.",
              },
              {
                img: "wallet",
                title: "Instant Pay",
                text: "Drivers can instantly deposit their earnings into their bank account by registering with Instant Pay. Instant Pay is the fastest way to get paid.",
              },
            ].map((item, i) => (
              <div className="berymo-box" key={i}>
                <img
                  src={`/images/${item.img}.png`}
                  alt={item.img}
                  className="icon"
                />
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>

        {/* DRIVER APP */}
        <div className="work">
          <div className="jerry">
            <h1>
              Driver app —
              <br />
              built with drivers
            </h1>
            <p>
              Drivers get paid per rider, making your income simple and
              transparent.
            </p>
            <div className="stone-btn">
              <a
                href="https://apps.apple.com/us/app/berymo-driver/id1440035432"
                target="_blank"
                rel="noopener noreferrer"
              >
                <AppStore />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.berymodriver"
                target="_blank"
                rel="noopener noreferrer"
              >
                <PlayStore />
              </a>
            </div>
          </div>
          <div className="phone-image">
            <img src="/images/driverapptra.png" alt="phone" />
          </div>
        </div>

        {/* PICKUP TO DROPOFF */}
        <div className="berymo-container">
          <h2>From pickup to dropoff, we are there for you</h2>
          <p className="berymo-subtext">
            Berymo Driver app offers unmatched privacy and security. We want to
            ensure that our drivers feel as
            <br />
            comfortable navigating through the map as the riders feel riding in
            your car.
          </p>
          <div className="berymo-grid">
            {[
              {
                img: "schedule",
                title: "On your Schedule",
                text: "Drive with Berymo and earn extra income wherever you are and whenever you want to drive.",
              },
              {
                img: "settings",
                title: "Top tier support",
                text: "Berymo provides top tier, 24/7 support for the times you need it most.",
              },
              {
                img: "star",
                title: "Rider ratings",
                text: "At the end of each ride you complete, you will have the option to rate your rider.",
              },
            ].map((item, i) => (
              <div className="berymo-box" key={i}>
                <img
                  src={`/images/${item.img}.png`}
                  alt={item.img}
                  className="icon"
                />
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
          <Link to="/safety" className="safety">
            learn more about Driver safety →
          </Link>
        </div>

        {/* IMAGE */}
        <div>
          <div className="driver-image">
            <img src="/images/driver-overview-general.jpg" alt="driver" />
          </div>
        </div>

        {/* DRIVER REQUIREMENTS */}
        <div className="driver-req-section">
          <h2>How to become a Berymo Driver</h2>
          <p className="intro-text">
            Berymo is always looking for new drivers. We only need a few
            documents to get started.
          </p>
          <div className="requirement-columns">
            <div className="column">
              <h3>Driver Requirements</h3>
              <ul>
                <li>✔ Be at least 21 years old.</li>
                <li>✔ Pass DMV and background checks.</li>
                <li>✔ Use an iPhone or Android smartphone.</li>
              </ul>
            </div>
            <div className="column">
              <h3>Vehicle Requirements</h3>
              <ul>
                <li>✔ 15-year-old or newer.</li>
                <li>✔ 4 doors or more.</li>
                <li>✔ At least 4 seats for riders.</li>
              </ul>
            </div>
            <div className="column">
              <h3>Document Requirements</h3>
              <ul>
                <li>✔ US Driver’s license for at least one year.</li>
                <li>✔ Proof of insurance and a car inspection.</li>
                <li>✔ Submit a photo of yourself.</li>
              </ul>
            </div>
          </div>
        </div>

        {/* FAQ SECTION */}
        <div
          style={{
            padding: isMobile ? "40px 15px" : "60px 0",
            backgroundColor: "#fff",
            fontFamily: "Helvetica, Arial, sans-serif",
          }}
        >
          <h1
            style={{
              fontSize: isMobile ? "24px" : "26px",
              fontWeight: "bold",
              marginBottom: isMobile ? "25px" : "40px",
              textAlign: "left",
              color: "#000",
              lineHeight: isMobile ? "28px" : "32px",
              maxWidth: "1000px",
              margin: isMobile ? "0 auto" : "0 auto 40px",
            }}
          >
            {isMobile ? (
              <>
                Frequently asked
                <br />
                questions from our
                <br />
                drivers
              </>
            ) : (
              "Frequently asked questions from our drivers"
            )}
          </h1>

          <div
            style={{
              maxWidth: isMobile ? "100%" : "1000px",
              margin: "0 auto",
            }}
          >
            {questions.map((item, index) => (
              <div
                key={index}
                onClick={() => toggleQuestion(index)}
                onMouseEnter={() => setHoverIndex(index)}
                onMouseLeave={() => setHoverIndex(null)}
                style={{
                  borderBottom: "1px solid #e0e0e0",
                  padding: isMobile ? "18px 0" : "22px 0",
                  cursor: "pointer",
                }}
              >
                {/* Question Row */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      fontSize: isMobile ? "16px" : "18px",
                      fontWeight: "bold",
                      color:
                        activeIndex === index || hoverIndex === index
                          ? "#FD5C63"
                          : "#000",
                      lineHeight: "22px",
                      width: "90%",
                    }}
                  >
                    {item.question}
                  </span>

                  <span
                    style={{
                      fontSize: isMobile ? "22px" : "24px",
                     fontWeight: "bold", 
                      color:
                        activeIndex === index || hoverIndex === index
                          ? "#FD5C63"
                          : "#000",
                    }}
                  >
                    {activeIndex === index ? "×" : "+"}
                  </span>
                </div>

                {/* Answer */}
                <div
                  style={{
                    maxHeight: activeIndex === index ? "400px" : "0px",
                    opacity: activeIndex === index ? 1 : 0,
                    overflow: "hidden",
                    transition: "max-height 0.4s ease, opacity 0.3s ease",
                    fontSize: isMobile ? "14px" : "16px",
                    lineHeight: "22px",
                    color: "#444",
                    paddingTop: activeIndex === index ? "10px" : "0px",
                    textAlign: "left",
                  }}
                >
                  {item.answer}
                </div>
              </div>
            ))}
          </div>
        </div>

        
        <div
    style={{
        backgroundColor: "#FEF4F5",
        clipPath: "polygon(0 7%, 100% 0, 100% 100%, 0% 100%)",
        padding: isMobile ? "120px 20px 20px" : "120px 20px 50px",
        textAlign: "center",
    }}
>
    <h1
        style={{
            fontSize: isMobile ? "20px" : "25px",
            marginBottom: isMobile ? "10px" : "17px",
            fontWeight: 700,
            lineHeight: isMobile ? "30px" : "42px",
            color: "#000",
        }}
    >
       Earn great money on your schedule
    </h1>

    <p
        style={{
            fontSize: isMobile ? "14px" : "16px",
            color: "#555",
            lineHeight: isMobile ? "22px" : "26px",
            margin: 0,
        }}
    >
        Drive with Berymo and earn up to $1,800 for the first 60 loops you complete in your city
    </p>

    {/* 👇 Wrap button in <a> to navigate */}
    <a
        href="https://play.google.com/store/apps/details?id=com.berymodriver"
        style={{ textDecoration: "none" }} // Remove underline
    >
        <button
            style={{
                backgroundColor: "#fd5c63",
                color: "#fff",
                border: "none",
                padding: isMobile ? "0.8rem 1.6rem" : "1rem 2.5rem",
                width: isMobile ? "42%" : "200px",
                cursor: "pointer",
                fontWeight: "bold",
                fontSize: isMobile ? "0.7rem" : "0.69rem",
                textTransform: "uppercase",
                textAlign: "center",
                fontFamily: "'Segoe UI', Arial, sans-serif",
                borderRadius: "5px",
                transition: "background-color 0.3s ease, transform 0.2s ease",
                marginTop: isMobile ? "24px" : "30px",
                marginBottom: isMobile ? "40px" : "60px",
            }}
            onMouseOver={(e) => {
                e.target.style.backgroundColor = "#474747";
                e.target.style.transform = "translateY(-2px)";
            }}
            onMouseOut={(e) => {
                e.target.style.backgroundColor = "#fd5c63";
                e.target.style.transform = "scaleX(1)";
            }}
        >
            SIGN UP TO drive
        </button>
    </a>
</div>

      </div>

    </>
  );
};

export default Driver;
